module.exports = __webpack_public_path__ + "static/media/Hunter.bcbc8dac.svg";